module.exports = __webpack_public_path__ + "img/code.120bef2c.png";